// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AcceptanceInputController from "./acceptance_input_controller"
application.register("acceptance-input", AcceptanceInputController)

import ActivationModalController from "./activation_modal_controller"
application.register("activation-modal", ActivationModalController)

import ActivitiesController from "./activities_controller"
application.register("activities", ActivitiesController)

import AddonsController from "./addons_controller"
application.register("addons", AddonsController)

import AffirmController from "./affirm_controller"
application.register("affirm", AffirmController)

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import AutoplayVideoController from "./autoplay_video_controller"
application.register("autoplay-video", AutoplayVideoController)

import BarReviewAskALegalQuestionFormController from "./bar_review_ask_a_legal_question_form_controller"
application.register("bar-review-ask-a-legal-question-form", BarReviewAskALegalQuestionFormController)

import BarReviewCalendarController from "./bar_review_calendar_controller"
application.register("bar-review-calendar", BarReviewCalendarController)

import BarReviewCalendarPopupController from "./bar_review_calendar_popup_controller"
application.register("bar-review-calendar-popup", BarReviewCalendarPopupController)

import BarReviewCourseProgressController from "./bar_review_course_progress_controller"
application.register("bar-review-course-progress", BarReviewCourseProgressController)

import BarReviewEssayFeedbackController from "./bar_review_essay_feedback_controller"
application.register("bar-review-essay-feedback", BarReviewEssayFeedbackController)

import BarReviewGradedTaskSubmissionController from "./bar_review_graded_task_submission_controller"
application.register("bar-review-graded-task-submission", BarReviewGradedTaskSubmissionController)

import BarReviewPerformanceStatsController from "./bar_review_performance_stats_controller"
application.register("bar-review-performance-stats", BarReviewPerformanceStatsController)

import BillMyFirmFormController from "./bill_my_firm_form_controller"
application.register("bill-my-firm-form", BillMyFirmFormController)

import BookmarkModalController from "./bookmark_modal_controller"
application.register("bookmark-modal", BookmarkModalController)

import CancelStudyAidsSubscriptionController from "./cancel_study_aids_subscription_controller"
application.register("cancel-study-aids-subscription", CancelStudyAidsSubscriptionController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import CaseBriefRequestsController from "./case_brief_requests_controller"
application.register("case-brief-requests", CaseBriefRequestsController)

import CasebookRequestSectionController from "./casebook_request_section_controller"
application.register("casebook-request-section", CasebookRequestSectionController)

import CasebriefsPopupController from "./casebriefs_popup_controller"
application.register("casebriefs-popup", CasebriefsPopupController)

import ChangeCardsViewController from "./change_cards_view_controller"
application.register("change-cards-view", ChangeCardsViewController)

import CheckboxDropdownController from "./checkbox_dropdown_controller"
application.register("checkbox-dropdown", CheckboxDropdownController)

import CleBundlesFixedSidebarController from "./cle_bundles_fixed_sidebar_controller"
application.register("cle-bundles-fixed-sidebar", CleBundlesFixedSidebarController)

import CleCourseInfoPanelController from "./cle_course_info_panel_controller"
application.register("cle-course-info-panel", CleCourseInfoPanelController)

import CleCourseProgressController from "./cle_course_progress_controller"
application.register("cle-course-progress", CleCourseProgressController)

import CleCoursesSearchController from "./cle_courses_search_controller"
application.register("cle-courses-search", CleCoursesSearchController)

import CleJurisdictionCoursesSearchController from "./cle_jurisdiction_courses_search_controller"
application.register("cle-jurisdiction-courses-search", CleJurisdictionCoursesSearchController)

import CleOnboardingExperienceController from "./cle_onboarding_experience_controller"
application.register("cle-onboarding-experience", CleOnboardingExperienceController)

import CleOnboardingPracticeAreaController from "./cle_onboarding_practice_area_controller"
application.register("cle-onboarding-practice-area", CleOnboardingPracticeAreaController)

import ClePracticeAreaCoursesSearchController from "./cle_practice_area_courses_search_controller"
application.register("cle-practice-area-courses-search", ClePracticeAreaCoursesSearchController)

import CoachmarksV2Controller from "./coachmarks_v2_controller"
application.register("coachmarks-v2", CoachmarksV2Controller)

import CollapseController from "./collapse_controller"
application.register("collapse", CollapseController)

import ComparisonTableController from "./comparison_table_controller"
application.register("comparison-table", ComparisonTableController)

import ContentSearchController from "./content_search_controller"
application.register("content-search", ContentSearchController)

import CookieDeleteController from "./cookie_delete_controller"
application.register("cookie-delete", CookieDeleteController)

import CopyToClipboardController from "./copy_to_clipboard_controller"
application.register("copy-to-clipboard", CopyToClipboardController)

import CouponFieldController from "./coupon_field_controller"
application.register("coupon-field", CouponFieldController)

import DarkmodeController from "./darkmode_controller"
application.register("darkmode", DarkmodeController)

import DeleteAndRedirectController from "./delete_and_redirect_controller"
application.register("delete-and-redirect", DeleteAndRedirectController)

import DiagnosticReviewController from "./diagnostic_review_controller"
application.register("diagnostic-review", DiagnosticReviewController)

import DisableWhenInvalidController from "./disable_when_invalid_controller"
application.register("disable-when-invalid", DisableWhenInvalidController)

import DisablerController from "./disabler_controller"
application.register("disabler", DisablerController)

import DismissibleController from "./dismissible_controller"
application.register("dismissible", DismissibleController)

import DomainEntryFormController from "./domain_entry_form_controller"
application.register("domain-entry-form", DomainEntryFormController)

import DownloadViaVisitController from "./download_via_visit_controller"
application.register("download-via-visit", DownloadViaVisitController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DynamicContentController from "./dynamic_content_controller"
application.register("dynamic-content", DynamicContentController)

import ElementVisibilityCheckboxToggleController from "./element_visibility_checkbox_toggle_controller"
application.register("element-visibility-checkbox-toggle", ElementVisibilityCheckboxToggleController)

import ElementVisibilityMultiToggleController from "./element_visibility_multi_toggle_controller"
application.register("element-visibility-multi-toggle", ElementVisibilityMultiToggleController)

import ElementVisibilitySelectToggleController from "./element_visibility_select_toggle_controller"
application.register("element-visibility-select-toggle", ElementVisibilitySelectToggleController)

import ElementVisibilityToggleController from "./element_visibility_toggle_controller"
application.register("element-visibility-toggle", ElementVisibilityToggleController)

import EventTriggerController from "./event_trigger_controller"
application.register("event-trigger", EventTriggerController)

import FileDropController from "./file_drop_controller"
application.register("file-drop", FileDropController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import FlashcardController from "./flashcard_controller"
application.register("flashcard", FlashcardController)

import FlashcardsFeedbackModalController from "./flashcards_feedback_modal_controller"
application.register("flashcards-feedback-modal", FlashcardsFeedbackModalController)

import FlashcardsSidebarController from "./flashcards_sidebar_controller"
application.register("flashcards-sidebar", FlashcardsSidebarController)

import HtmxFormSubmitterController from "./htmx_form_submitter_controller"
application.register("htmx-form-submitter", HtmxFormSubmitterController)

import InputTextCounterController from "./input_text_counter_controller"
application.register("input-text-counter", InputTextCounterController)

import InputmaskController from "./inputmask_controller"
application.register("inputmask", InputmaskController)

import LessonsSidebarController from "./lessons_sidebar_controller"
application.register("lessons-sidebar", LessonsSidebarController)

import LicenseAgreementModalController from "./license_agreement_modal_controller"
application.register("license-agreement-modal", LicenseAgreementModalController)

import LinkDropdownController from "./link_dropdown_controller"
application.register("link-dropdown", LinkDropdownController)

import LiveWebcastAttendanceVerificationController from "./live_webcast_attendance_verification_controller"
application.register("live-webcast-attendance-verification", LiveWebcastAttendanceVerificationController)

import LoginFormController from "./login_form_controller"
application.register("login-form", LoginFormController)

import ManageCasebookSubjectController from "./manage_casebook_subject_controller"
application.register("manage-casebook-subject", ManageCasebookSubjectController)

import ManageJurisdictionController from "./manage_jurisdiction_controller"
application.register("manage-jurisdiction", ManageJurisdictionController)

import MenuSearchController from "./menu_search_controller"
application.register("menu-search", MenuSearchController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ModalOpenOnLoadController from "./modal_open_on_load_controller"
application.register("modal-open-on-load", ModalOpenOnLoadController)

import ModalTriggerController from "./modal_trigger_controller"
application.register("modal-trigger", ModalTriggerController)

import MultiLinkDropdownController from "./multi_link_dropdown_controller"
application.register("multi-link-dropdown", MultiLinkDropdownController)

import NestedCheckboxesController from "./nested_checkboxes_controller"
application.register("nested-checkboxes", NestedCheckboxesController)

import NotificationsListController from "./notifications_list_controller"
application.register("notifications-list", NotificationsListController)

import OfflineDetectionBannerController from "./offline_detection_banner_controller"
application.register("offline-detection-banner", OfflineDetectionBannerController)

import OnDemandAttendanceVerificationController from "./on_demand_attendance_verification_controller"
application.register("on-demand-attendance-verification", OnDemandAttendanceVerificationController)

import OnetrustController from "./onetrust_controller"
application.register("onetrust", OnetrustController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import PreferencesBaseController from "./preferences_base_controller"
application.register("preferences-base", PreferencesBaseController)

import PreferencesCollapseController from "./preferences_collapse_controller"
application.register("preferences-collapse", PreferencesCollapseController)

import PreferencesDropdownController from "./preferences_dropdown_controller"
application.register("preferences-dropdown", PreferencesDropdownController)

import PreferencesToggleController from "./preferences_toggle_controller"
application.register("preferences-toggle", PreferencesToggleController)

import PreventDefaultController from "./prevent_default_controller"
application.register("prevent-default", PreventDefaultController)

import PrintLinkController from "./print_link_controller"
application.register("print-link", PrintLinkController)

import PublicInterestPricingApplicationFormController from "./public_interest_pricing_application_form_controller"
application.register("public-interest-pricing-application-form", PublicInterestPricingApplicationFormController)

import QanalyticsController from "./qanalytics_controller"
application.register("qanalytics", QanalyticsController)

import QuimbeeDataController from "./quimbee_data_controller"
application.register("quimbee-data", QuimbeeDataController)

import QuizQuestionModalNavButtonController from "./quiz_question_modal_nav_button_controller"
application.register("quiz-question-modal-nav-button", QuizQuestionModalNavButtonController)

import ReenableSubmitController from "./reenable_submit_controller"
application.register("reenable-submit", ReenableSubmitController)

import ReloadController from "./reload_controller"
application.register("reload", ReloadController)

import ResourceIndexBulkActionFormController from "./resource_index_bulk_action_form_controller"
application.register("resource-index-bulk-action-form", ResourceIndexBulkActionFormController)

import ResponsiveInputController from "./responsive_input_controller"
application.register("responsive-input", ResponsiveInputController)

import SchoolDataFormController from "./school_data_form_controller"
application.register("school-data-form", SchoolDataFormController)

import ScrollIndicatorController from "./scroll_indicator_controller"
application.register("scroll-indicator", ScrollIndicatorController)

import ScrollspyController from "./scrollspy_controller"
application.register("scrollspy", ScrollspyController)

import SearchFilterController from "./search_filter_controller"
application.register("search-filter", SearchFilterController)

import SectionJumpController from "./section_jump_controller"
application.register("section-jump", SectionJumpController)

import SettingsController from "./settings_controller"
application.register("settings", SettingsController)

import SignUpFormModalController from "./sign_up_form_modal_controller"
application.register("sign-up-form-modal", SignUpFormModalController)

import SortableTableController from "./sortable_table_controller"
application.register("sortable-table", SortableTableController)

import StickyHeaderController from "./sticky_header_controller"
application.register("sticky-header", StickyHeaderController)

import SubmitOnFormChangeController from "./submit_on_form_change_controller"
application.register("submit-on-form-change", SubmitOnFormChangeController)

import TableRowUrlController from "./table_row_url_controller"
application.register("table-row-url", TableRowUrlController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TieredPricingController from "./tiered_pricing_controller"
application.register("tiered-pricing", TieredPricingController)

import TimerController from "./timer_controller"
application.register("timer", TimerController)

import TimezoneVisibilityToggleController from "./timezone_visibility_toggle_controller"
application.register("timezone-visibility-toggle", TimezoneVisibilityToggleController)

import TinymceController from "./tinymce_controller"
application.register("tinymce", TinymceController)

import TinymceSaveController from "./tinymce_save_controller"
application.register("tinymce-save", TinymceSaveController)

import ToggleSwitchController from "./toggle_switch_controller"
application.register("toggle-switch", ToggleSwitchController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TopnavMenuController from "./topnav_menu_controller"
application.register("topnav-menu", TopnavMenuController)

import TruncateController from "./truncate_controller"
application.register("truncate", TruncateController)

import UsStatesInteractiveMapController from "./us_states_interactive_map_controller"
application.register("us-states-interactive-map", UsStatesInteractiveMapController)

import UserTimeZoneHiddenInputController from "./user_time_zone_hidden_input_controller"
application.register("user-time-zone-hidden-input", UserTimeZoneHiddenInputController)

import ValidatedPhoneController from "./validated_phone_controller"
application.register("validated-phone", ValidatedPhoneController)

import VideoTrackingController from "./video_tracking_controller"
application.register("video-tracking", VideoTrackingController)

import VisitUrlViaSelectController from "./visit_url_via_select_controller"
application.register("visit-url-via-select", VisitUrlViaSelectController)

import WarnOnSessionChangeController from "./warn_on_session_change_controller"
application.register("warn-on-session-change", WarnOnSessionChangeController)

import WistiaCustomPlayerController from "./wistia_custom_player_controller"
application.register("wistia-custom-player", WistiaCustomPlayerController)

import WistiaLazyVideoController from "./wistia_lazy_video_controller"
application.register("wistia-lazy-video", WistiaLazyVideoController)

import WistiaVideoController from "./wistia_video_controller"
application.register("wistia-video", WistiaVideoController)
